import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import authSlice from "../slice/authSlice";
import userSlice from "../slice/userSlice";
import contactusSlice from "../slice/contactusSlice";
import contactSlice from "../slice/contactSlice";
import serviceReducer from "../slice/serviceSlice";
import galleryReducer from "../slice/gallerySlice";
import careerReducer from "../slice/careerSlice";
import faqReducer from "../slice/faqSlice";
import signupReducer from "../slice/signupSlice";
import signinReducer from "../slice/signinSlice";
import accountReducer from "../slice/accountSlice";

import rootSaga from "../apis/rootSaga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    contactUs: contactusSlice, // ✅ renamed (no duplicate)
    contact: contactSlice,
    services: serviceReducer,
    gallery: galleryReducer,
    career: careerReducer,
    faqs: faqReducer,
    signup: signupReducer,
    signin: signinReducer,
    account: accountReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: true }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
